var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F3CD;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.8,20.6c0.7-0.8,1.5-1.5,2.3-1.9s1.8-0.6,2.8-0.6s1.9,0.2,2.7,0.5s1.6,0.9,2.2,1.6s1.1,1.5,1.5,2.4 s0.5,1.9,0.5,2.9c0,1.5-0.3,2.8-1,4s-1.6,2.1-2.8,2.8c-1.2,0.7-2.6,1-4.1,1c-1.8,0-3.3-0.4-4.5-1.3c-1.3-0.8-2.2-2.1-2.9-3.8 s-1-3.7-1-6.1c0-2,0.2-3.7,0.6-5.3s1-2.8,1.8-3.9c0.8-1,1.7-1.8,2.8-2.3s2.3-0.8,3.7-0.8s2.5,0.3,3.5,0.8s1.8,1.2,2.3,1.9 s0.8,1.5,0.8,2.2c0,0.4-0.2,0.8-0.5,1.2c-0.3,0.4-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.1-1.2-0.4c-0.4-0.3-0.6-0.7-0.8-1.2 c-0.2-0.6-0.6-1.1-1.1-1.5s-1.1-0.6-1.8-0.6c-0.5,0-1.1,0.2-1.6,0.5s-1,0.8-1.4,1.3C18.4,15.8,17.9,17.7,17.8,20.6L17.8,20.6z  M22,30.3c1,0,1.9-0.4,2.6-1.3s1-2,1-3.4c0-1-0.2-1.8-0.5-2.5s-0.8-1.2-1.3-1.6S22.7,21,22,21s-1.3,0.2-1.9,0.5s-1.1,0.8-1.4,1.5 s-0.5,1.4-0.5,2.3c0,1.4,0.4,2.6,1.1,3.5S20.9,30.3,22,30.3L22,30.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt6);
export default __webpack_public_path__ + "static/media/CT6.d63bb4fe125f9928cd2828ef4eafb15c.svg";
export { ForwardRef as ReactComponent };